import axios from 'axios'

const state = {
    copied: {
        id: null,
        number: null,
        siteId: null,
        isCanceled: false
    },
    list: [],
};

const getters = {
    list: state => state.list,
    copiedContract: state => state.copied,
}

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    setCopy(state, payload) {
        state.copied = {
            id: payload.id,
            number: payload.number,
            siteId: payload.siteId,
            isCanceled: payload.isCanceled
        }
    }
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
};

const actions = {

    getContracts(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/contracts/index', payload, options)
            .then((response) => {
                return response
            })
    },

    getContractsFromClient(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/contracts/' + payload.id, payload, options)
            .then((response) => {
                return response
            })
    },

    getCompletedContractsFromClient(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/contracts/completed/' + payload.id)
            .then((response) => {
                return response
            })
    },

    storeCopiedContract(context, payload) {
        let contract = state.copied
        if(payload !== null) contract = payload

        context.commit('setCopy', contract)
    },

    copyContract(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/contracts/cache/copy', payload, options)
            .then((response) => {
                return response
            })
    },

    duplicateContract(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/contracts/duplicate', payload, options)
            .then((response) => {
                return response
            })
    },

    getCopiedContract() {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/contracts/cache/copied')
            .then((response) => {
                return response
            })
    },

    getContractDetails(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/contracts/' + payload.contractId)
            .then((response) => {
                return response
            })
    },

    getContractDeviceGroups(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/contracts/' + payload.contractId + '/device_groups')
            .then((response) => {
                return response
            })
    },

    getCancelTypes() {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/cancel_types')
            .then((response) => {
                return response
            })
    },
    
    checkContractNumber(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/contracts/fetch/same_number', payload, options)
            .then((response) => {
                return response
            })
    },

    addContract(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/contracts', payload, options)
            .then((response) => {
                return response
            })
    },

    updateContract(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/contracts/' + payload.contractId, payload, options)
            .then((response) => {
                return response
            })
    },

    updatePeriod(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/contract_periods/' + payload.periodId, payload, options)
            .then((response) => {
                return response
            })
    },

}

const contracts = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default contracts;
